export default function PackageCard({ title, price, subtitle, features, accent, badge }) {
  return (
    <div className={`package-card ${accent ? "featured" : ""}`}>
      {badge && <div className="feature-badge">{badge}</div>}

      <div className="package-header">
        <h3>{title}</h3>
        <div className="package-price">{price}</div>
        <p>{subtitle}</p>
      </div>

      <div className="package-body">
        <ul className="package-features">
          {features.map((f, i) => <li key={i}>{f}</li>)}
        </ul>

        <a href="#contact" className={`btn ${accent ? "btn-accent" : ""}`} 
           style={{ width: "100%", textAlign: "center" }}>
          Get Started
        </a>
      </div>
    </div>
  );
}
